<template>
    <div class="login">
    </div>
</template>
<script>
    import {mapMutations} from 'vuex'

    export default {
        name: 'login',
        methods: {
            ...mapMutations([
                'setUserInfo','setHttpInfo'
            ]),
            login: function () {
                this.$api.user.h5login({code: this.code}).then((res) => {
                    if (res.status * 1 === 200) {
                        let urid = res.data.user_info.member.id;
                        let token = res.data.user_info.access_token;
                        // this.setHttpInfo({urid,token});
                        localStorage.setItem('token', token);
                        localStorage.setItem('urid', urid);
                        this.$api.user.getUserInfo({urid, token}).then((res)=>{
                            let {data} = res;
                            Object.assign(data,{urid, token})
                            this.setUserInfo(data);
                            this.cf.getLastRouter().then((res) => {
                                this.$storage.remove('lastroute');
                                let {name,params}= res;
                                // console.log(res)
                                //用push拦截下次回退
                                this.$router.push({name,params})
                            })
                        })
                    } else {
                        this.$wechat.jsAuthorize()
                    }
                })
            }
        },

        data() {
            return {
                code: ""
            }
        },
        mounted() {
            this.$toast.loading()
            if (this.cf.isWeChat()) {
                let {code, state} = this.$route.query
                if (code && state === "authorize") {
                    this.code = code;
                    this.login();
                    return;
                }
                this.$wechat.jsAuthorize()
            } else {
                this.$toast.fail("请在微信中打开当前页面")
                this.$router.push({name:'index'})
            }

        }
    }
</script>
